<sag-ui-application-frame
    [applicationName]="'app.title' | translate"
    [logoUrl]="'assets/images/sag-logo/sie-logo-petrol-rgb.svg'"
    [logoUrlDark]="'assets/images/sag-logo/sie-logo-white-rgb.svg'"
    [logoAlt]="'app.logo-alt' | translate"
    [sidebarItems]="
        authService.isAuthenticated() && !isRouterPathUnauthorized() ? sidebarItems() : unauthorizedSidebarItems()
    "
    [bottomSidebarItems]="authService.isAuthenticated() && !isRouterPathUnauthorized() ? bottomSidebarItems() : []"
    [userRoles]="authService.userIdTokenClaims()?.roles || []"
    [skipToContentTarget]="'#main-content'"
    [skipToContentTargetLinkText]="'app.skip-to-main-content-link' | translate"
    [footerLinks]="footerLinks()"
>
    <ng-template #desktopHeaderContent>
        <app-header-menu class="flex items-center gap-2" />
    </ng-template>

    <ng-template #mobileHeaderContent>
        <app-header-menu class="flex flex-col-reverse space-y-4 w-full" />
    </ng-template>
    <!-- Main content area -->
    <div class="bg-light-bgColorPrimary dark:bg-dark-bgColorPrimary pr-4" id="main-content">
        @if (!authService.isAuthLoading() && !isUserLoading()) {
            <router-outlet />
        } @else {
            <div class="fixed top-0 left-0 w-full h-full flex justify-center items-center">
                <div class="flex flex-col items-center">
                    <div class="flex">
                        <div
                            class="h-4 w-4 dark:bg-dark-actionColor bg-light-actionColor rounded-full animate-pulse mx-1 delay-0s"
                        ></div>
                        <div
                            class="h-4 w-4 dark:bg-dark-actionColor bg-light-actionColor rounded-full animate-pulse mx-1 delay-500ms"
                        ></div>
                        <div
                            class="h-4 w-4 dark:bg-dark-actionColor bg-light-actionColor rounded-full animate-pulse mx-1 delay-500ms"
                        ></div>
                    </div>
                    <div class="mt-6 dark:text-dark-actionColor text-light-actionColor">
                        {{ 'app.loading' | translate }}
                    </div>
                </div>
            </div>
        }
    </div>
</sag-ui-application-frame>
